import type { FC } from 'react';
import { IcCalendarcheck, IcLocation, IcStarFill } from '@yanolja-rnd/nol-icons';

/*
 * Info
 * 사용 영역: 국내숙소, 레저, 해외숙소
 * 타입 정보: Banner, List, Card
 */

export interface UnitInfoProps {
  locationInfo?: string | null;
  locationDetails?: string[] | null; // 해외숙소의 경우 위치정보가 여러개일 수 있음
  dateInfo?: string | null;
  review?: { noScoreText?: string | null; score: string; count: string } | null;
}

export const UnitInfo: FC<UnitInfoProps> = ({ dateInfo, locationDetails, review }) => {
  if (!dateInfo && !locationDetails && !review) return null;

  return (
    // 텍스트 공통 영역 스타일링
    <div className="pm-2 text-fill-neutral-main typography-body-14-regular">
      {/*  기간정보 */}
      {!!dateInfo && (
        <div className="mb-4 flex items-center justify-start gap-2">
          <IcCalendarcheck className="shrink-0" width={16} height={16} />
          <span className="line-clamp-1 text-start">{dateInfo}</span>
        </div>
      )}
      {/* 국내숙소 - 위치정보, 레저 - 랜드마크 정보, 해외숙소 - 위치정보, 랜드마크 정보*/}
      {!!locationDetails &&
        locationDetails.map((location, index) => (
          <div key={index} className="mb-4 flex items-center justify-start gap-2">
            <IcLocation className="shrink-0" width={16} height={16} />
            <span className="line-clamp-1 text-start">{location}</span>
          </div>
        ))}
      {/* 후기정보 */}
      {!!review && (
        <div className="mb-4 flex items-center justify-start">
          {review?.noScoreText ? (
            <p className="flex items-center justify-start gap-2">
              <span className="typography-body-14-bold">{review.noScoreText}</span>
              <span>{review.count}</span>
            </p>
          ) : (
            <>
              <IcStarFill width={16} height={16} />
              <p className="flex items-center justify-start gap-2 pl-2">
                <span className="typography-body-14-bold">{review.score}</span>
                <span>{review.count}</span>
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export const UnitCardInfo: FC<UnitInfoProps> = ({ review }) => {
  if (!review) return null;

  return (
    // 텍스트 공통 영역 스타일링
    <div className="flex min-h-20 items-center text-fill-neutral-main">
      {/* 후기정보 */}
      {!!review && (
        <div className="flex items-center justify-start">
          {review?.noScoreText ? (
            <p className="flex items-center justify-start gap-1">
              <span className="typography-body-12-bold">{review.noScoreText}</span>
              <span className="typography-body-12-regular">{review.count}</span>
            </p>
          ) : (
            <>
              <IcStarFill width={12} height={12} />
              <p className="flex items-center justify-start gap-2 pl-2">
                <span className="typography-body-12-bold">{review.score}</span>
                <span className="typography-body-12-regular">{review.count}</span>
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
};
